// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Btn_confirm:focus {
  background-color: #ffffff !important;
  color: black !important;
  border: 1px solid;
}

.Btn_confirm:hover {
  background-color: #ffffff !important;
  color: black !important;
  border: 1px solid;
}

.highlight-active {
  background-color: #17a2b8 !important;
  color: white !important;
  border-left: 4px solid #0c5460;
}
.highlight-active h6 {
  color: white !important;
}

.expression-builder-section {
  margin-top: 1rem;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 4px;
  border: 1px solid #dee2e6;
}

.expression-toggle {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
}
.expression-toggle label {
  margin-left: 0.5rem;
  margin-bottom: 0;
  cursor: pointer;
}

.function-select {
  margin-bottom: 1rem;
}

.parameter-form .param-row {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
}
.parameter-form .param-row label {
  min-width: 120px;
  margin-bottom: 0;
  font-weight: 500;
}
.parameter-form .param-row input, .parameter-form .param-row select {
  flex: 1;
  margin-left: 0.5rem;
}

.expression-preview {
  margin-top: 1rem;
  padding: 0.75rem;
  background-color: #e9ecef;
  border-radius: 4px;
  font-family: monospace;
  font-size: 0.9em;
  word-break: break-all;
}

.function-description {
  font-size: 0.85em;
  color: #6c757d;
  font-style: italic;
  margin-bottom: 0.75rem;
}

.category-label {
  font-weight: 600;
  color: #495057;
  font-size: 0.8em;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}`, "",{"version":3,"sources":["webpack://./src/app/hl7viewer/add-mapping-dialog/add-mapping-dialog.component.scss"],"names":[],"mappings":"AAGA;EACE,oCAAA;EACA,uBAAA;EACA,iBAAA;AAFF;;AAKA;EACE,oCAAA;EACA,uBAAA;EACA,iBAAA;AAFF;;AAMA;EACE,oCAAA;EACA,uBAAA;EACA,8BAAA;AAHF;AAKE;EACE,uBAAA;AAHJ;;AAQA;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;AALF;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;AALF;AAOE;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;AALJ;;AASA;EACE,mBAAA;AANF;;AAUE;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;AAPJ;AASI;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;AAPN;AAUI;EACE,OAAA;EACA,mBAAA;AARN;;AAaA;EACE,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,qBAAA;AAVF;;AAaA;EACE,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;AAVF;;AAaA;EACE,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;AAVF","sourcesContent":["// Styles for Add Mapping Dialog\r\n// Matches application's generic popup styling (xmlMappings/confirm-dialog pattern)\r\n\r\n.Btn_confirm:focus {\r\n  background-color: #ffffff !important;\r\n  color: black !important;\r\n  border: 1px solid;\r\n}\r\n\r\n.Btn_confirm:hover {\r\n  background-color: #ffffff !important;\r\n  color: black !important;\r\n  border: 1px solid;\r\n}\r\n\r\n// Highlight for Add Mapping heading when active\r\n.highlight-active {\r\n  background-color: #17a2b8 !important;\r\n  color: white !important;\r\n  border-left: 4px solid #0c5460;\r\n  \r\n  h6 {\r\n    color: white !important;\r\n  }\r\n}\r\n\r\n// Expression builder styles\r\n.expression-builder-section {\r\n  margin-top: 1rem;\r\n  padding: 1rem;\r\n  background-color: #f8f9fa;\r\n  border-radius: 4px;\r\n  border: 1px solid #dee2e6;\r\n}\r\n\r\n.expression-toggle {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 0.5rem;\r\n  \r\n  label {\r\n    margin-left: 0.5rem;\r\n    margin-bottom: 0;\r\n    cursor: pointer;\r\n  }\r\n}\r\n\r\n.function-select {\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.parameter-form {\r\n  .param-row {\r\n    display: flex;\r\n    align-items: center;\r\n    margin-bottom: 0.5rem;\r\n    \r\n    label {\r\n      min-width: 120px;\r\n      margin-bottom: 0;\r\n      font-weight: 500;\r\n    }\r\n    \r\n    input, select {\r\n      flex: 1;\r\n      margin-left: 0.5rem;\r\n    }\r\n  }\r\n}\r\n\r\n.expression-preview {\r\n  margin-top: 1rem;\r\n  padding: 0.75rem;\r\n  background-color: #e9ecef;\r\n  border-radius: 4px;\r\n  font-family: monospace;\r\n  font-size: 0.9em;\r\n  word-break: break-all;\r\n}\r\n\r\n.function-description {\r\n  font-size: 0.85em;\r\n  color: #6c757d;\r\n  font-style: italic;\r\n  margin-bottom: 0.75rem;\r\n}\r\n\r\n.category-label {\r\n  font-weight: 600;\r\n  color: #495057;\r\n  font-size: 0.8em;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.5px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
